export const COLORS = ["#61D5A9", "#EB9195", "#CBCDFD", "#FBC1B9", "#EAACE3"];